import { render, staticRenderFns } from "./competeProductSale.vue?vue&type=template&id=3c111020&scoped=true"
import script from "./competeProductSale.vue?vue&type=script&lang=js"
export * from "./competeProductSale.vue?vue&type=script&lang=js"
import style0 from "./competeProductSale.vue?vue&type=style&index=0&id=3c111020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c111020",
  null
  
)

export default component.exports